import { COLORS } from "../constants";

export default function TagFilter({ tags, active, onSelect }) {
  return (
    <div style={{ display: "flex", gap: "6px", flexWrap: "wrap", marginBottom: "12px" }}>
      {["", ...tags].map(tag => (
        <button key={tag || "all"} onClick={() => onSelect(tag)} style={{ padding: "4px 12px", borderRadius: "16px", fontSize: "12px", cursor: "pointer", border: `0.5px solid ${active === tag ? COLORS.blue : COLORS.border}`, background: active === tag ? COLORS.blueLight : "transparent", color: active === tag ? COLORS.blue : COLORS.textSecondary }}>{tag || "All"}</button>
      ))}
    </div>
  );
}